export const ENTITY_PATH_ID = '/:packages/:packageId/:versionUuid/:entity/:entityId';
export const EDITOR_PATH_ID = '/:packages/:packageId/:versionUuid/:entity/:editor/:entityId';
export const ENTITY_PATH = '/:packages/:packageId/:versionUuid/:entity';
export const PACKAGE_VERSION_PATH = '/:packages/:packageId/versions';
